import React from "react";
import { MessageCircle, HeartHandshake, ShieldCheck, Users } from "lucide-react";
import { WHATSAPP_LINK } from "@/lib/api";

export default function Adolescentes() {
  return (
    <div data-testid="page-adolescentes">
      <section className="section">
        <div className="container-narrow grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-7">
            <span className="text-eyebrow">Atendimento para adolescentes</span>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl mt-5 leading-[1.1] text-[#2C352D]">
              Uma escuta cuidadosa<br /> para a travessia da adolescência.
            </h1>
            <div className="mt-8 prose-soft">
              <p>
                A adolescência é um tempo de transformação intensa. O corpo muda, os laços se reconfiguram,
                novas questões sobre identidade, sexualidade e futuro emergem. É também um tempo em que o
                sofrimento psíquico pode aparecer com força.
              </p>
              <p>
                Ofereço um espaço próprio do jovem — onde ele pode falar sem ser interpretado, julgado ou
                comparado. Um lugar só dele, onde aquilo que parece confuso pode ganhar contorno.
              </p>
            </div>
          </div>
          <div className="lg:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_escuta-acolhimento/artifacts/xb887edx_ChatGPT%20Image%2027%20de%20jun.%20de%202026%2C%2020_08_33.png"
              alt="Atendimento para adolescentes"
              className="rounded-[2rem] w-full h-[520px] object-cover soft-shadow"
              data-testid="adolescentes-image"
            />
          </div>
        </div>

        <div className="container-narrow grid md:grid-cols-3 gap-6 mt-20">
          <div data-testid="adolescentes-card-funciona" className="bg-white rounded-3xl p-8 border border-[#8BA88E]/15 soft-shadow">
            <HeartHandshake className="text-[#8BA88E]" size={26} />
            <h3 className="font-serif text-2xl mt-4 text-[#2C352D]">Como funciona</h3>
            <p className="mt-3 text-[#5B685C] font-light leading-relaxed">
              Sessões online semanais, em horário combinado, dentro de um ambiente acolhedor e confortável
              para o adolescente.
            </p>
          </div>
          <div data-testid="adolescentes-card-escuta" className="bg-white rounded-3xl p-8 border border-[#8BA88E]/15 soft-shadow">
            <ShieldCheck className="text-[#8BA88E]" size={26} />
            <h3 className="font-serif text-2xl mt-4 text-[#2C352D]">Sigilo e respeito</h3>
            <p className="mt-3 text-[#5B685C] font-light leading-relaxed">
              O conteúdo das sessões é sigiloso. A confiança é a base do trabalho com o jovem.
            </p>
          </div>
          <div data-testid="adolescentes-card-pais" className="bg-white rounded-3xl p-8 border border-[#8BA88E]/15 soft-shadow">
            <Users className="text-[#8BA88E]" size={26} />
            <h3 className="font-serif text-2xl mt-4 text-[#2C352D]">Participação dos pais</h3>
            <p className="mt-3 text-[#5B685C] font-light leading-relaxed">
              Quando necessária, é conduzida com cuidado — sempre preservando a privacidade e a confiança
              do adolescente.
            </p>
          </div>
        </div>

        <div className="container-narrow mt-16 text-center">
          <a
            data-testid="adolescentes-whatsapp-btn"
            href={WHATSAPP_LINK("Olá Cristina, gostaria de informações sobre o atendimento para adolescentes.")}
            target="_blank"
            rel="noreferrer"
            className="btn-whatsapp"
          >
            <MessageCircle size={18} /> Falar sobre atendimento
          </a>
        </div>
      </section>
    </div>
  );
}
